import { SVGProps, Ref, forwardRef } from 'react';

export const CardLinesStackedCrossFilledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <g>
                    <path
                        d="M13.748 2.034C13.152.742 11.442.5 8 .5S2.848.742 2.252 2.034a9 9 0 0 1 1.575-.377C4.982 1.479 6.379 1.43 8 1.43s3.018.049 4.174.227c.55.084 1.08.203 1.574.377"
                        fill="currentColor"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M8 2.83c-6.439 0-8.028.792-7.359 6.335S2.23 15.5 8 15.5q.454 0 .87-.007a4.733 4.733 0 0 1 6.53-6.691C15.955 3.587 14.296 2.83 8 2.83m2.667 4.87H3.334V6.3h7.333zm-3.333 2.834H3.667v-1.4h3.667z"
                        fill="currentColor"
                    />
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M16 12.667a3.333 3.333 0 1 1-6.667 0 3.333 3.333 0 0 1 6.667 0m-4.182 0-.99-.99.848-.849.99.99.99-.99.849.849-.99.99.99.99-.849.848-.99-.99-.99.99-.848-.849z"
                        fill="currentColor"
                    />
                </g>
            </g>
        </svg>
    )
);
CardLinesStackedCrossFilledSize16Glyph.displayName = 'CardLinesStackedCrossFilledSize16Glyph';
